import { signal } from "@preact/signals-react";
export const logClientNumber = signal("");
export const logClientName = signal("");
export const logClientMobileNumber = signal("");
export const logClientCompany = signal("");
export const logClientBranch = signal("");
export const logToken = signal("");
export const logClientOTP = signal("");
export const signalPagePath = signal(null);
export const signalUrl = signal("https://alguthmi.co/API/B2BAppAPI");

export async function authenticateUser(cliCode, mobileNo, pass, language) {
  const url = signalUrl + "/authenticate.php";
  const username = "Guthmi";
  const password = "ApiCal2023@_2115&";
  const basicAuth = btoa(username + ":" + password);

  const options = {
    method: "POST",
    headers: {
      Authorization: `Basic ${basicAuth}`,
      "Content-Type": "application/json",
      "origin": "http://alguthmi.co",
    },
    body: JSON.stringify({ cliCode, mobileNo, pass, language }),
  };

  try {
    const response = await fetch(url, options);

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error:", error);
  }
}

